import { render, staticRenderFns } from "./ModalCourierTeleport.vue?vue&type=template&id=02ac6848&"
import script from "./ModalCourierTeleport.vue?vue&type=script&lang=js&"
export * from "./ModalCourierTeleport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports